<!-- <ion-grid class="confirmation-body p-20"> -->
  <div class="confirmation-body p-20">
  <ion-row class="p-0">
    <ion-col *ngIf="showCloseIcon" class="display-end p-0">
      <img [mat-dialog-close] src="././assets/icon/close_icon.png" class="cp">
    </ion-col>
  </ion-row>
  <ion-row *ngIf="showSuccessIcon" class="p-0 mb-10 horizontal-center">
    <img src="././assets/icon/successGreencheckMarkIcon.svg">
  </ion-row>
  <ion-row *ngIf="showSuccessMessage" class="p-0 mb-10 horizontal-center">
    <p class="fs-18 font_medium cl-black text-center">Successful</p>
  </ion-row>
  <ion-row *ngIf="msgTitle != ''" class="p-0 mb-10 horizontal-center">
    <p class="fs-18 font_medium cl-black text-center">{{msgTitle}}</p>
  </ion-row>
  <ion-row *ngIf="msg != ''" class="p-0 display-center">
    <p class="fs-16 font_medium cl-black text-center">{{msg}}</p>
  </ion-row>
  <ion-row class="p-0 mt-20">
    <ion-col class="horizontal-center">
      <button *ngIf="button1" class="font_medium back_btn mr-30" (click)="btn1Action()">{{button1}}</button>
      <button *ngIf="button2" class="font_medium add_btn" [ngStyle]="{'background-color': color}" (click)="btn2Action()" >{{button2}}</button>
    </ion-col>
  </ion-row>
</div>
<!-- </ion-grid> -->

